<template>
    <div>

        <div v-if="emailSend" class="reg-text-notice">
            На указанный e-mail адрес отправлено письмо для подтвреждения. <br>
            Пройдите по указанной в письме ссылке.
        </div>
        <form v-else class="main-page" @submit.prevent="sendData">

            <div class="main-page-nav">
                <div class="link"><router-link to="/login">Вход</router-link></div>
                <div class="divider">/</div>
                <div class="link active">Регистрация</div>
            </div>

            <material-input v-model="email" :error="errors.email" type="text">E-mail</material-input>

            <material-input v-model="password" :error="errors.password" type="password">Пароль</material-input>

            <material-input v-model="password2" type="password">Пароль еще раз</material-input>

            <div class="reg-terms" @mouseenter="chbxHovered = true" @mouseleave="chbxHovered = false" @click="chbxChecked = !chbxChecked">
                <div style="padding-right: 17px; flex-shrink: 0">
                    <div class="checkbox" :class="{hover: chbxHovered, checked: chbxChecked}"></div>
                </div>

                <div style="flex-grow: 1;">
                    Я ознакомился с
                    <a href="/docs/terms.pdf" target="_blank">условиями использования</a>
                    и принимаю их.
                </div>
            </div>

            <div style="text-align: center">
                <button type="submit" :class="{disabled: !chbxChecked}">Зарегистрироваться</button>
            </div>

        </form>

    </div>

</template>

<style lang="scss" scoped>
    .reg-text-notice{
        max-width: 400px;
        font-size: 20px;
    }

    .disabled{
        color: #8a8a8a;
        cursor: not-allowed;
        &:hover {
            color: #8a8a8a;
        }
    }

    .reg-terms{
        display: flex;
        font-weight: 400;
        margin-top: 25px;
        font-size: 15px;
        line-height: 25px;
        cursor: pointer;
        a{
            color:#4B87CC;
            &:hover{
                color: #5EA9FF;
            }
        }
    }
</style>

<script>
    import axios from 'axios'
    import _ from 'lodash'
    import materialInput from '../../elements/material-input'

    export  default {
        components: {
            materialInput
        },
        data(){
            return {
                valid: true,
                loading: false,
                errors:{
                  email: '',
                  password: '',
                },
                email: '',
                password: '',
                password2: '',
                emailSend: false,
                chbxHovered: false,
                chbxChecked: false,
            }
        },
        mounted(){

        },
        methods: {
            sendData(){
                if(!this.chbxChecked){
                    return;
                }
                this.loading = true
                axios.post('/legacy/register',{
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password2,
                }).then((req)=>{
                    _.forEach(this.errors, (v, k)=>{
                        this.errors[k] = '';
                    })
                    if(req.data.done){
                        this.emailSend = true;
                    }
                }).catch((req)=>{
                    let data = req.response.data;
                    if(data.errors){
                        _.forEach(this.errors, (v, k)=>{
                            this.errors[k] = data.errors[k] ? data.errors[k].join('\n') : '';
                        })
                    }
                }).finally(()=>{
                    this.loading = false
                })
            }
        }
    }
</script>
